import { activities, supportChannels } from "@/mocks/fanCommunity";
import { badgeClasses, filledChip } from "./tone";

const iconTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function SupportSection() {
  return (
    <section id="support" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-700">
            <i className="ri-flashlight-line" />
            后援会 · 应援企划
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            让热爱被看见，为捷克应援
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            无论线上打卡还是线下奔赴，总有一种适合你的应援方式。加入后援会分站，在企划里找到你的位置。
          </p>
        </div>

        {/* channels */}
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {supportChannels.map((c) => (
            <div
              key={c.title}
              className="rounded-xl border border-background-200/80 bg-background-50 p-6 transition-colors hover:border-accent-200"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${iconTone[c.tone]}`}
              >
                <i className={c.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
          ))}
        </div>

        {/* activities */}
        <div className="mt-12 flex items-center justify-between">
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900">应援现场精选</h3>
          <a
            href="#join"
            className="inline-flex whitespace-nowrap items-center gap-1 text-sm font-medium text-accent-700 hover:text-accent-800"
          >
            参与应援
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
          {activities.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-xl bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 md:h-48 w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  title={`${a.title} - 吃瓜捷克应援活动`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${filledChip[a.typeTone]}`}
                >
                  {a.type}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h4 className="font-heading text-base font-semibold text-foreground-950">{a.title}</h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.desc}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-earth-line" />
                    {a.scope}
                  </span>
                  <span className={`rounded-full px-2.5 py-1 ${badgeClasses[a.typeTone]}`}>{a.progress}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}